


























































































































































































































































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import {
  updateAdmin,
  AdminCommonReq,
  deleteAdmin,
  NewAdminReq,
  newAdmin,
  users,
  getQiniuToken,
} from "@/api/admin";
import { RouteConfig } from "vue-router";
import { ResCode, PagingReq, Admin, Company } from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { ElStep } from "element-ui/types/step";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import xlsx from "xlsx";
import * as uuid from "uuid";
import { ElForm } from "element-ui/types/form";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
  },
})
export default class AdminList extends Vue {
  private bDisableCompany = false;
  private admin: Admin = <Admin>{};
  private newAdmin: NewAdminReq = <NewAdminReq>{};
  private dialogEditAdmin = false;
  private dialogDelete = false;
  private dialogAdd = false;
  private list: Admin[] = [];
  private backRoles: string[] = [];
  private frontRoles: string[] = [];
  private listLoading: boolean = true;
  private total = 0;
  private searchAdmin = <Admin>{};
  private isSearch = false;
  private queryCompanys: Company[] = [];
  private loading = false;
  private nextPage = 1;
  private disableStates: {
    index: number;
    state: string;
  }[] = [];
  private listQuery: AdminCommonReq = <AdminCommonReq>{
    page: 1,
    pageSize: 10,
  };
  private resetSearch() {
    this.searchAdmin = <Admin>{};
  }
  private search() {
    this.isSearch = true;
    this.listQuery.page = 1;
    this.getList();
  }
  public async getList() {
    this.listLoading = true;
    let req: AdminCommonReq = <AdminCommonReq>{};
    if (this.isSearch) {
      req.admin = this.searchAdmin;
      req.page = this.listQuery.page;
      req.pageSize = this.listQuery.pageSize;
    } else {
      req = this.listQuery;
    }
    const res = await users(req);
    if (!!res && res.code === ResCode.SUCCESS) {
      this.list = res.data.users.list;
      this.total = res.data.users.totalCount;
      this.backRoles = res.data.users.backRoles;
      this.frontRoles = res.data.users.frontRoles;
    }
    this.listLoading = false;
  }
  public async exportExecl() {
    let json = await this.getAllData();
    let ss = xlsx.utils.json_to_sheet(json, null); //通过工具将json转表对象
    let keys = Object.keys(ss).sort(); //排序 [需要注意，必须从A1开始]
    let ref = keys[1] + ":" + keys[keys.length - 1]; //这个是定义一个字符串 也就是表的范围[A1:C5]
    let workbook = {
      //定义操作文档
      SheetNames: ["nodejs-sheetname"], //定义表明
      Sheets: {
        "nodejs-sheetname": ss, //表对象[注意表明]
      },
    };
    xlsx.writeFile(
      workbook,
      "admins" + Math.floor(Date.now() / 1000) + ".xls",
      null
    ); //将数据写入文件
  }
  public async getAllData(): Promise<Admin[]> {
    let pageSize = 100;
    let page = 1;
    let reqs: AdminCommonReq[] = [];
    let promises: Promise<Admin[]>[] = [];
    let maxPage = Math.ceil(this.total / pageSize);
    let lists: Admin[] = [];
    while (maxPage - page >= 0) {
      let req: AdminCommonReq = <AdminCommonReq>{};
      req.page = page;
      req.pageSize = pageSize;
      let promise = this.getListForAllData(req);
      promises.push(promise);
      page++;
    }
    let listss = await Promise.all(promises);
    for (let list of listss) {
      lists = lists.concat(list);
    }
    return lists;
  }

  public async getListForAllData(req: AdminCommonReq): Promise<Admin[]> {
    let self = this;
    return new Promise<Admin[]>(function (value, rej) {
      if (self.isSearch) {
        req.admin = self.searchAdmin;
      }
      users(req)
        .then(function (res) {
          if (!!res && res.code === ResCode.SUCCESS) {
            let list = res.data.users.list;
            value(list);
          }
        })
        .catch(function (reason) {
          rej(reason);
        });
    });
  }
  public onSelectChangeCompany() {
    this.queryCompany("");
  }
  public clickEdit(scope) {
    this.admin = Object.assign({}, scope.row);
    this.dialogEditAdmin = true;
    this.imageUrl = this.admin.portrait;
    this.bDisableCompany = !!this.admin.companyID;
    this.queryCompanys.push(<Company>{
      id: this.admin.companyID,
      name: this.admin.companyName,
    });
  }
  public clickDelete(scope) {
    this.admin = Object.assign({}, scope.row);
    this.dialogDelete = true;
  }
  public clickAdd(scope) {
    this.admin = <Admin>{};
    this.dialogAdd = true;
    this.imageUrl = "";
  }
  public validateToUpdateAdmin() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.updateAdmin();
      } else {
        return false;
      }
    });
  }
  public async updateAdmin() {
    const res = await updateAdmin(<AdminCommonReq>{ admin: this.admin });
    if (res && res.code === ResCode.SUCCESS) {
      this.dialogEditAdmin = false;
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.UpdateAdminSuccess").toString(),
        type: "success",
      });
      this.getList();
      this.getList();
    }
  }

  public dataRules = {
    name: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    email: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    userName: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    frontRole: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    phone: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    position: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    companyID: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
  };

  private validateNotNull(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }

  private validatePass(rule: any, value: string, callback: any) {
    if (value.length < 8) {
      callback(
        new Error(this.$t("validate.passwordMustGreaterThan8").toString())
      );
    } else {
      callback();
    }
  }
  private validatePass2(rule: any, value: string, callback: any) {
    if (value !== this.admin.password) {
      callback(new Error(this.$t("validate.twoPasswordNotEqual").toString()));
    } else {
      callback();
    }
  }

  public async deleteUser() {
    const res = await deleteAdmin(<AdminCommonReq>{ admin: this.admin });
    if (res && res.code === ResCode.SUCCESS) {
      this.dialogDelete = false;
      this.$notify({
        title: this.$t("common.success").toString(),
        message:
          this.admin.deleteState === 0
            ? this.$t("notification.DisableAdminSuccess").toString()
            : this.$t("notification.EnableAdminSuccess").toString(),
        type: "success",
      });
      this.getList();
    }
  }

  private uploadQiniuUrl: string = "https://up-z2.qiniup.com"; // 七牛云服务器地址
  private imageUrl = "";
  private qiniuData = {
    key: "", // 图片名字处理
    token: "", // 七牛云token
    domain: "",
  };
  private beforeUploadGetKey() {
    this.qiniuData.key = "meter/admin/portrait/" + uuid.v1();
  }
  private successUploadGetKey(response, file, fileList) {
    this.imageUrl = this.qiniuData.domain + "/" + this.qiniuData.key;
    this.$notify({
      title: this.$t("common.success").toString(),
      message: this.$t("notification.UploadSuccess").toString(),
      type: "success",
      duration: 2000,
    });
    this.admin.portrait = this.imageUrl;
  }

  public async qiniuToken() {
    const res = await getQiniuToken();
    if (res && res.code === ResCode.SUCCESS) {
      this.qiniuData.token = res.data.token;
      this.qiniuData.domain = res.data.domain;
    }
  }
  private created() {
    this.disableStates = [
      { index: 0, state: this.$t("diableState.enabled").toString() },
      { index: 1, state: this.$t("diableState.disabled").toString() },
    ];
    this.qiniuToken();
    this.getList();
  }

  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }
}
